import { Badge } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';

const SolidBadge = (
  {
    children = null,
    color = 'green'
  }, ...props
) => {
  const mappingColor = {
    bg: {
      'green': '#44AB4A',
      'red': '#EA2036',
      'orange': '#FF711A'
    },
    fontColor: {
      'green': '#FFF',
      'red': '#FFF',
      'orange': '#FFF'
    }
  };
  return (
    <Badge {...props} bg={mappingColor.bg[color] || '#E4E5E7'} c={mappingColor.fontColor[color] || '#A0A4A8'} style={{ textTransform: 'none', fontSize: 14, fontWeight: 500, padding: '3.5px 12px' }}>
      {children}
    </Badge>
  );
};

export default SolidBadge;

SolidBadge.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['green', 'red']),
};
